import { render, staticRenderFns } from "./ToccaVinoFooter.vue?vue&type=template&id=624811ba&scoped=true&"
var script = {}
import style0 from "./ToccaVinoFooter.vue?vue&type=style&index=0&id=624811ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624811ba",
  null
  
)

export default component.exports